import styles from "./adminusers.module.css"
import { Button } from "../../../components/button/Button"
import { useEffect, useState } from "react"
import { createUser } from "../../../fetch/users"
import { useLocation } from "wouter"
import { useWatcher } from "../../../lib/state/useWatcher"
import { tenantState } from "../../../store/tenant"
import { District, UserRole } from "../../../../types"
import { getDistricts } from "../../../fetch/districts"
import { useForm, useWatch } from "react-hook-form"
import { toast } from "react-toastify"
import { Form } from "@/components/ui/form"
import { InputField } from "@/components/ui/form/InputField"
import styled from "styled-components"
import { DropdownField } from "@/components/ui/form/DropdownField"

const StyledForm = styled.form`
  max-width: 750px;
  margin: 0 auto;
  gap: 8px;
  display: flex;
  flex-direction: column;
`

const Row = styled.div`
  display: grid;
  grid-template-columns: repeat(2, calc(50% - 8px));
  gap: 16px;
`

const Title = styled.h1`
  font-size: 36px;
  font-weight: 700;
  line-height: 40px;
  letter-spacing: -0.02em;
  text-align: left;
`

const StyledButton = styled(Button)`
  align-self: end;
  margin-top: 8px;
`

type FormInputs = {
  email: string
  name: string
  role: UserRole[]
  coeficient: number
  permissionsDistricts: number[]
}

export const CreateUser = () => {
  const {
    settings: { features },
  } = useWatcher(tenantState)
  const [, setLocation] = useLocation()
  const [loading, setLoading] = useState(false)
  const form = useForm<FormInputs>()
  const role = useWatch({
    control: form.control,
    name: "role",
  })
  const [districts, setDistricts] = useState<District[]>([])
  const hasFeatureDistricts = features?.["districts"]

  const roleOptions = [
    { id: UserRole.User, name: "Darbinieks" },
    ...(hasFeatureDistricts
      ? [{ id: UserRole.Manager, name: "📋 Menedžeris" }]
      : []),
    { id: UserRole.Admin, name: "✅ Administrators" },
  ]

  const init = () => {
    getDistricts().then(async (res) => {
      const json = await res.json()
      if (json) {
        setDistricts(json)
      }
    })
  }
  useEffect(() => {
    init()
  }, [])

  const onSubmit = async (values: FormInputs) => {
    setLoading(true)
    console.log(values)
    const { email, role, name, coeficient, permissionsDistricts } = values
    let hasError = false
    if (!name) {
      form.setError("name", { type: "required" })
      hasError = true
    }
    if (coeficient < 0) {
      form.setError("coeficient", { type: "required" })
      hasError = true
    }
    if (!email) {
      form.setError("email", { type: "required" })
      hasError = true
    } else if (email.indexOf("@") < 0) {
      form.setError("email", { type: "required" })
      hasError = true
    }
    if (!role?.[0]) {
      form.setError("role", { type: "required" })
      hasError = true
    } else if (
      (role?.[0] === UserRole.User || role?.[0] === UserRole.Manager) &&
      hasFeatureDistricts &&
      !permissionsDistricts?.length
    ) {
      form.setError("permissionsDistricts", { type: "required" })
      hasError = true
    }

    if (hasError) {
      setLoading(false)
      return
    }

    try {
      await createUser({
        name,
        coeficient: +coeficient || 0,
        email,
        role: role?.[0],
        permissions: {
          projects: [],
          opGroups: [],
          ...(hasFeatureDistricts && {
            districts:
              permissionsDistricts?.map((id) => ({
                id,
                name: districts?.find((d) => d.id === id)?.name || "",
              })) ?? [],
          }),
        },
      })
      setLocation("..")
      setLoading(false)
    } catch (err) {
      setLoading(false)
      toast("Darbība nav izdevusies, lūdzu mēģiniet vēlreiz", { type: "error" })
    }
  }

  return (
    <div className={styles.root}>
      <Form {...form}>
        <StyledForm onSubmit={form.handleSubmit(onSubmit)}>
          <Title>Pievienot jaunu lietotāju</Title>
          <InputField
            control={form.control}
            name="email"
            placeholder="E-pasts"
            label="E-pasts"
            error={form.formState.errors.email}
          />
          <Row>
            <InputField
              control={form.control}
              name="name"
              placeholder="Vārds, Uzvārds"
              label="Vārds, Uzvārds"
              error={form.formState.errors.name}
            />
            <InputField
              control={form.control}
              name="coeficient"
              placeholder="Koeficients"
              label="Koeficients"
              error={form.formState.errors.coeficient}
              inputProps={{ type: "number" }}
            />
          </Row>
          <Row>
            <DropdownField
              control={form.control}
              name="role"
              placeholder="Piekļuves tiesības"
              label="Piekļuves tiesības"
              options={roleOptions}
            />
            {[UserRole.User, UserRole.Manager].includes(Number(role?.[0])) &&
              features?.["districts"] && (
                <DropdownField
                  control={form.control}
                  name="permissionsDistricts"
                  placeholder="Iecirkņi"
                  label="Iecirkņi"
                  multiple
                  options={[
                    { id: undefined, name: "Neviens" },
                    ...districts.map(({ name, id }) => ({
                      id,
                      name,
                    })),
                  ]}
                />
              )}
          </Row>
          <StyledButton type="submit" disabled={loading}>
            Pievienot lietotāju
          </StyledButton>
        </StyledForm>
      </Form>
    </div>
  )
}
